import { render, staticRenderFns } from "./ProjectTemplate5.vue?vue&type=template&id=763c10b5&scoped=true"
import script from "./ProjectTemplate5.vue?vue&type=script&lang=js"
export * from "./ProjectTemplate5.vue?vue&type=script&lang=js"
import style0 from "./ProjectTemplate5.vue?vue&type=style&index=0&id=763c10b5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763c10b5",
  null
  
)

export default component.exports